"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSplitSeparator = exports.StyledSplitSeparatorDraggable = exports.StyledSplitSeparatorSeparator = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../../helpers");
exports.StyledSplitSeparatorSeparator = styled_components_1.default.div `
    z-index: 3;
    border-color: ${({ theme }) => theme.colorBorderMain};
    border-width: 0;
    flex-shrink: 0;

    ${({ isRow }) => isRow
    ? (0, styled_components_1.css) `
                  width: 0;
                  border-right-style: solid;
                  border-right-width: 1px;
              `
    : (0, styled_components_1.css) `
                  height: 0;
                  border-top-style: solid;
                  border-top-width: 1px;
              `}
`;
exports.StyledSplitSeparatorDraggable = styled_components_1.default.div `
    position: absolute;
    z-index: 2;
    transition: background-color 0.25s ease;
    display: flex;
    flex-direction: ${({ isRow }) => (isRow ? 'row' : 'column')};
    align-items: stretch;
    justify-content: center;

    ${({ theme }) => (0, styled_components_1.css) `
        background-color: rgba(${(0, helpers_1.hexToRgba)(theme.colorBorderMain, 0).join(',')});
    `}

    &:hover {
        ${({ resizable, theme }) => resizable &&
    (0, styled_components_1.css) `
                background-color: rgba(${(0, helpers_1.hexToRgba)(theme.colorBorderMain, 0.5).join(',')});
            `}
    }

    ${({ isRow }) => isRow
    ? (0, styled_components_1.css) `
                  top: 0;
                  left: -5px;
                  bottom: 0;
                  right: -5px;
              `
    : (0, styled_components_1.css) `
                  top: -5px;
                  left: 0;
                  bottom: -5px;
                  right: 0;
              `}

    ${({ resizable, isRow }) => resizable &&
    (0, styled_components_1.css) `
            &:hover {
                cursor: ${isRow ? 'col-resize' : 'row-resize'};
            }
        `}
`;
exports.StyledSplitSeparator = styled_components_1.default.div `
    position: relative;
    flex-shrink: 0;
    display: flex;
    flex-direction: ${({ isRow }) => (isRow ? 'row' : 'column')};
    align-content: stretch;

    &:not(:hover),
    &:hover {
        z-index: 2;
    }

    ${({ isRow }) => isRow
    ? (0, styled_components_1.css) `
                  width: 0;
              `
    : (0, styled_components_1.css) `
                  height: 0;
              `}
`;
//# sourceMappingURL=SplitSeparator.styles.js.map